import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { LiveBet } from '@features/live-bets/interfaces/live-bet.interface';
import { ContextMenuService } from '@core/services/context-menu.service';
import { GamesEnum } from '@core/enums/games.enum';
import { GameIconComponent } from '../../../../core/components/game-icon/game-icon.component';
import { DatePipe, DecimalPipe } from '@angular/common';
import { BalanceIconComponent } from '../../../../core/components/balance-icon/balance-icon.component';
import { Router } from '@angular/router';
import { GamesService } from '@core/services/games.service';
import { v4 } from 'uuid';
import { listAnimation } from '@core/utils/animations.util';
import { PlayerRowComponent } from '../../../../core/components/player-row/player-row.component';

@Component({
  selector: 'app-live-bets-table',
  imports: [
    GameIconComponent,
    DatePipe,
    BalanceIconComponent,
    DecimalPipe,
    PlayerRowComponent,
  ],
  templateUrl: './live-bets-table.component.html',
  styleUrl: './live-bets-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  animations: [listAnimation],
})
export class LiveBetsTableComponent {
  contextMenuService = inject(ContextMenuService);
  gamesService = inject(GamesService);
  router = inject(Router);

  maxCount = 10;

  bets = input.required<LiveBet[]>();

  modifiedBets = computed(() => {
    const gameNames: Record<string, keyof typeof GamesEnum> = {
      king: 'King',
      'high roller jackpot': 'Jackpot',
      '30 max jackpot': 'Jackpot',
      wheel: 'Wheel',
      upgrader: 'Upgrade',
      coinflip: 'Coinflip',
      plinko: 'Plinko',
      towers: 'Towers',
      mines: 'Mines',
      'case battle': 'Case Battles',
      caseopening: 'Cases',
    };

    const transformed = this.bets().map((bet) => {
      const game = gameNames[bet.game.toLowerCase()];
      return {
        ...bet,
        game,
        id: v4(),
        handleNavigate: () => this.handleNavigateByGame(game, bet),
      };
    });

    // Sort by timestamp in descending order (newest first)
    // No need for reverse since we're already sorting newest to oldest
    return transformed.sort((a, b) => b.time - a.time).slice(0, this.maxCount);
  });

  private handleNavigateByGame(
    game: keyof typeof GamesEnum,
    liveBet?: LiveBet
  ) {
    if (game === 'Case Battles' && liveBet?.gameid) {
      this.router.navigate([
        '/',
        this.gamesService.gamesMap()[game].link,
        liveBet!.gameid,
      ]);
    } else {
      this.router.navigate(['/', this.gamesService.gamesMap()[game].link]);
    }
  }
}
